import api from './api';

export const checkInUser = async (clientId) => {
    try {
        const response = await api.post(`/users/${clientId}/check-in`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCheckInHistory = async (clientId, startDate, endDate) => {
    try {
        const response = await api.get(`/users/${clientId}/check-ins/${startDate}/${endDate}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Add more user-related API calls here as needed 